<template>
  <div class="onlineassessmentresult">
    <b-container fluid>
      <b-row class="mycontainer-main">
        <!-- <b-col cols="12" md="6" class="mycontainer-main m-borders">
                    <div class="row h-100 ml-5">
                        <div class="col-sm-12 align-self-center text-left">
                            <div>
                                <div id="bar" class="bar">
                                </div>
                                <h2 class="fade-in" >{{answers.name}}'s Results</h2>
                                <p class="fade-in" >Here are the suggestions for your routine</p>
                                <b-button squared style="background-color: black;" class="main-button fade-in">{{ $t('common.make-appointment') }} </b-button>                                
                            </div>
                        </div>
                    </div>
                </b-col> -->
        <b-col cols="12" md="4" class="pl-5 leftcontent">
          <h6 class="my-0" style="color: grey">
            {{ $t("onlineassessmentresults.results") }}
          </h6>
          <h2>{{ answers.name }}</h2>
          <br />
          <h1 style="font-weight: 900; font-size: 1.9em">
            {{ $t("onlineassessmentresults.jumbo_desc") }}
          </h1>
          <!-- <h1 style="font-weight: 900; font-size: 1.9em;"> /shop now or wait. </h1> -->
          <!-- <hr style="width: 70%; margin-left: -10%;"> -->
          <appt-button v-bind:color="'d'" />
        </b-col>

        <b-col cols="12" md="7" class="mycontainer-main">
          <!-- <p> {{answers}} </p> -->
          <b-card class="opp">
            <b-card-title>
              {{ $t("onlineassessmentresults.thankyou") }}</b-card-title
            >
            <b-card-text>{{ display.main }}</b-card-text>
            <!-- <b-card-text>Age: {{answers.age}}</b-card-text> -->
          </b-card>

          <b-card class="mt-3">
            <b-card-title>
              {{ $t("onlineassessmentresults.suggestions") }}</b-card-title
            >
            <b-card-text>
              <ul>
                <li v-if="answers.activeIngr == false">
                  {{ display.activeIngr }}
                </li>
                <li v-if="answers.multipleBrands == false">
                  {{ display.multipleBrands }}
                </li>
                <li v-if="answers.applyOrder == false">
                  {{ display.applyOrder }}
                </li>
                <li v-if="answers.regularRoutine == false">
                  {{ display.regularRoutine }}
                </li>
                <!-- <li v-if="answers.results.none == true">{{display.none}}</li> -->
              </ul>
            </b-card-text>
          </b-card>

          <b-row class="mt-4 mb-2">
            <b-col>
              <h3>{{ $t("onlineassessmentresults.whilewait") }}...</h3>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <b-card
                :img-src="require('../assets/images/oa_shop.png')"
                overlay
                text-variant="white"
              >
                <b-card-title
                  ><strong>{{
                    $t("onlineassessmentresults.shop")
                  }}</strong></b-card-title
                >
              </b-card>
              <b-card>
                <b-card-title>{{
                  $t("onlineassessmentresults.shopskintype")
                }}</b-card-title>
                <b-card-text>{{
                  $t("onlineassessmentresults.shop_desc")
                }}</b-card-text>

                <b-button
                  v-for="(l, index) in answers.concerns"
                  :key="index"
                  squared
                  variant="dark"
                  style="background-color: black"
                  size="md"
                  class="main-button shadow mt-2"
                  :href="'https://www.moncoachbeaute.ca/' + l"
                >
                  {{ $t("onlineassessmentresults.shopbutton") }}: {{ l }}
                </b-button>
              </b-card>
            </b-col>

            <b-col cols="12" md="6">
              <b-card
                :img-src="require('../assets/images/oa_online.png')"
                overlay
                text-variant="white"
              >
                <b-card-title
                  ><strong>{{
                    $t("onlineassessmentresults.consultation")
                  }}</strong></b-card-title
                >
              </b-card>
              <b-card>
                <b-card-title>{{
                  $t("onlineassessmentresults.consultationschedule")
                }}</b-card-title>
                <b-card-text>{{
                  $t("onlineassessmentresults.consultation_desc")
                }}</b-card-text>
                <b-button
                  squared
                  variant="dark"
                  style="background-color: black"
                  size="md"
                  class="shadow mt-2"
                  to="/onlineconsultation/"
                  >{{ $t("common.learn-more") }}
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { store, mutations } from "@/store/store.js";

const enResult = {
  main: "Your answers have been submitted to our team for review. We will connect with you very shortly to discuss different options. Look in your inbox in the next days to receive a personalized message from a member of our team!",
  activeIngr:
    "Active ingredients play an important role in your skincare products, you should make sure to combine the appropriate ones together",
  multipleBrands:
    " Using different brands of products can create a confusion to your skin and end up with new concerns",
  applyOrder:
    " Applying your products is the right order is very important, it helps your products performing the way they should.",
  regularRoutine:
    " Its tough to keep a regular routine but we can help. it is important for long lasting results.",
  none: "You have a good routine but we may be able to optimize the products you use for better results",
};

const frResult = {
  main: "Vos réponses ont été soumises à notre équipe et sont présentement en révision. Nous communiquerons avec vous par courriel sous peu pour discuter des différentes options qui s'offrent à vous.  Surveillez votre boîte de courriels dans les prochains jours pour recevoir un message personnel d'un membre de notre équipe! ",
  activeIngr:
    "Les ingrédients actifs jouent un rôle important dans vos produits, il faut être attentif à l’utilisation et à la combinaison de ceux-ci",
  multipleBrands:
    " Utiliser plusieurs marques de produits peut créer une confusion à votre peau et vous pourriez avoir de nouvelles préoccupations",
  applyOrder:
    " L’ordre d’application des produits est importante et aide vos produits à performer sur votre peau comme ils se doivent",
  regularRoutine:
    " Il est difficile d’être assidu sur sa routine de soin de la peau, mais la routine est d’une importance primordiale pour avoir des résultats à long terme.",
  none: "Vous avez une bonne routine mais nous pouvons être en mesure d'optimiser les produits que vous utilisez pour de meilleurs résultats",
};

export default {
  name: "onlineassessmentresult",
  // props: ['form'],
  data() {
    return {
      msg: "",
      answers: [],
      display: "",
      info: "",
      loading: true,
      errored: false,
      resultproductlink: "https://moncoachbeaute.ca/",
    };
  },
  methods: {
    setData() {
      this.answers = store.onlineassessment;
      if (this.$i18n.locale == "fr") {
        this.display = frResult;
      } else this.display = enResult;
      // console.log(this.answers);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.setData();
  },
};
</script>

<style scoped>
.mycontainer-main {
  min-height: calc(90vh);
}

.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
}
.card-img-top {
  width: 100%;
  height: 20rem;
  object-fit: cover;
}
.opp,
.opp .card-text {
  background-color: black;
  color: white;
}
.overtopimage {
  margin-top: -10vh;
}
</style>


// WEBPACK FOOTER //
// src/pages/OnlineAssessmentResults.vue